<div class="auth-background"></div>
<div class="auth-container">
  <mat-card>
    <mat-card-title> {{'MAIN.APP_NAME' | translate}}</mat-card-title>
    <form [formGroup]="authForm" (submit)="login()">


      <mat-form-field>
        <input type="email" formControlName="email" matInput placeholder="{{'COMMON.EMAIL' | translate}}">
        <mat-icon class="light" matSuffix>{{'email'}}</mat-icon>
      </mat-form-field>

      <mat-form-field>
        <input formControlName="password" matInput placeholder="{{'COMMON.PASSWORD' | translate}}"
               [type]="hide ? 'password' : 'text'">
        <mat-icon class="light" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>

      <button [disabled]="!authForm.valid" mat-raised-button color="primary">{{'COMMON.LOGIN' | translate}}</button>
    </form>
  </mat-card>

</div>
